import React from "react";
import EngineClusterPage from "../../../../components/pages/_new/super/engines/EngineClusterPage";

const PingoraClusterPage = () => <EngineClusterPage engineType="PINGORA" />;

export default PingoraClusterPage;
